export const SET_USER_TYPE = 'SET_USER_TYPE';
export const SET_AFTER_LOGIN = 'SET_AFTER_LOGIN';
export const RESET_AFTER_LOGIN = 'RESET_AFTER_LOGIN';
export const SET_PROPS = 'SET_PROPS';
export const SET_CONTENT_DATA_PUBLICITY = 'SET_CONTENT_DATA_PUBLICITY';
export const SET_MULTI_PBI_NEXT_EPISODE_ADS = 'SET_MULTI_PBI_NEXT_EPISODE_ADS';
export const SET_DATA_NEXT_EPISODE_ADS = 'SET_DATA_NEXT_EPISODE_ADS';
export const SET_URL_ADS = 'SET_URL_ADS';
export const SET_KIND_OF_PLAY_BUTTON_ADS = 'SET_KIND_OF_PLAY_BUTTON_ADS';
export const RESET_DATA_ABOUT_ADS = 'RESET_DATA_ABOUT_ADS';

export const setUserType = (payload) => dispatch => {
    dispatch({
        type: SET_USER_TYPE,
        payload
    });
};

export const setAfterLogin = (payload) => dispatch => {
    dispatch({
        type: SET_AFTER_LOGIN,
        payload
    });
};

export const setContentDataPublicity = (payload) => dispatch => {
  dispatch({
    type: SET_CONTENT_DATA_PUBLICITY,
    payload
  });
};

export const setMultiPBINextEpisodeAds = (payload) => dispatch => {
  dispatch({
    type: SET_MULTI_PBI_NEXT_EPISODE_ADS,
    payload
  });
}
export const setDataNextEpisodeAds = (payload) => dispatch => {
  dispatch({
    type: SET_DATA_NEXT_EPISODE_ADS,
    payload
  });
}
export const setUrlAds = (payload) => dispatch => {
  dispatch({
    type: SET_URL_ADS,
    payload
  });
}
export const setKindOfPlayButtonAds = (payload) => dispatch => {
  dispatch({
    type: SET_KIND_OF_PLAY_BUTTON_ADS,
    payload
  });
}

export const resetDataAboutAds = () => dispatch => {
  dispatch({
    type: RESET_DATA_ABOUT_ADS,
  });
}

export const resetAfterLogin = () => dispatch => {
    dispatch({
        type: RESET_AFTER_LOGIN
    });
};

export const setProps = (payload) => dispatch => { 
  dispatch({
      type: SET_PROPS,
      payload
  });
};


// WEBPACK FOOTER //
// ./src/actions/ads.js